export default __webpack_public_path__ + "static/media/G0860.Breech_06-SemiR-baby_out.1695378180000.2bd602ef.jpg";